// src/components/Hero.jsx
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/2merative_logo.webp";

export default function Hero() {
  const imgRef = useRef(null);
  const rafId = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      rafId.current = requestAnimationFrame(() => {
        const y = window.scrollY * 0.3;
        if (imgRef.current) imgRef.current.style.transform = `translateY(${y}px)`;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <section
      className="relative overflow-hidden flex flex-col items-center justify-center px-6 pt-20 pb-8 text-center text-white min-h-[400px]"
      style={{
        background: "linear-gradient(270deg,#a0c4ff,#457b9d,#a0c4ff)",
        backgroundSize: "600% 600%",
        animation: "gradientAnimation 20s ease infinite",
      }}
    >
      <img
        ref={imgRef}
        src={logo}
        alt="2merative web design Adelaide logo"
        width={240}
        height={100}
        loading="eager"
        decoding="async"
        fetchpriority="high"
        className="mb-6 select-none rounded-3xl shadow-lg object-contain spin-once hover:spin-hover will-change-transform"
      />

      <h1 className="text-4xl md:text-5xl font-bold max-w-4xl mb-4 drop-shadow-lg">
        Web Design Adelaide for Growing Businesses
      </h1>

      <p className="text-lg md:text-xl max-w-2xl mb-6 drop-shadow-md">
        Affordable, thoughtful websites built to help Adelaide businesses look
        credible, load fast, and turn more visitors into enquiries.
      </p>

      <Link
        to="/contact"
        className="inline-block px-8 py-3 rounded-lg bg-white text-blue-700 font-semibold shadow-lg hover:bg-blue-50 transition"
      >
        Take the First Step
      </Link>

      <style>{`
        @keyframes gradientAnimation {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes spinOnce {
          from { transform: rotate(0); }
          to { transform: rotate(360deg); }
        }

        .spin-once {
          animation: spinOnce 1.5s ease-in-out both;
        }

        .spin-hover:hover {
          animation: spinOnce 0.35s ease-in-out both;
        }

        @media (prefers-reduced-motion: reduce) {
          section {
            animation: none !important;
          }

          .spin-once,
          .spin-hover:hover {
            animation: none !important;
          }
        }
      `}</style>
    </section>
  );
}